import { message } from "antd";

const handleMessages = (res, param = "response") => {
  if (!res.success) {
    message.error(res.error?.[param] || "Ocurrió un error");
    return false;
  }

  const content = res.data?.[param];
  if (typeof content === "string") {
    message.success(content);
  }

  return true;
};

export default handleMessages;
